
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll';

const navLinks = [
  { to: 'home', label: 'Home' },
  { to: 'overview', label: 'Crisis' },
  { to: 'research', label: 'Approach' },
  { to: 'features', label: 'Features' },
  { to: 'demo', label: 'Demo' },
  { to: 'advantages', label: 'Why Us' },
  { to: 'impact', label: 'Roadmap' },
  { to: 'contact', label: 'Contact' },
];

const Header = () => {
  return (
    <Nav>
      <Logo>MindBridge</Logo>
      <NavLinks>
        {navLinks.map(link => (
          <li key={link.to}>
            <Link to={link.to} smooth={true} duration={500} spy={true} offset={-80}>
              {link.label}
            </Link>
          </li>
        ))}
      </NavLinks>
    </Nav>
  );
};

export default Header;

const Nav = styled.nav`
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 1rem 2rem;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
`;

const Logo = styled.h1`
  font-family: 'Poppins', sans-serif;
  font-size: 1.5rem;
  color: var(--primary-blue-dark);
  margin: 0;
  cursor: pointer;
`;

const NavLinks = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  gap: 2rem;

  @media (max-width: 768px) {
    display: none; // Simple responsive behavior for now
  }

  li {
    a {
      font-family: 'Inter', sans-serif;
      font-weight: 600;
      color: var(--text-dark);
      cursor: pointer;
      position: relative;
      padding-bottom: 5px;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0;
        height: 2px;
        background-color: var(--primary-blue-light);
        transition: width 0.3s ease;
      }

      &:hover::after,
      &.active::after {
        width: 100%;
      }
    }
  }
`;
